import { createEntityAdapter } from '@reduxjs/toolkit';
import { stringPropertyComparator } from '@utils/common.utils';
import { useReducer } from 'react';

import { ActivationAndFlightPlan } from '@/types/utm/flightPlan.types';

const activationAndFlightPlansAdapter = createEntityAdapter<ActivationAndFlightPlan, number>({
  selectId: (activationAndFlightPlan) => activationAndFlightPlan.activation.id,
  sortComparer: (a, b) => stringPropertyComparator('name')(a.flightPlan, b.flightPlan),
});

const initialState = activationAndFlightPlansAdapter.getInitialState();
export const ActivationAndFlightPlanSelectors = activationAndFlightPlansAdapter.getSelectors();

export type ActivationAndFlightPlansStateAction =
  | { type: 'ADD'; payload: ActivationAndFlightPlan }
  | { type: 'UPDATE'; payload: { activationId: number; activationAndFlightPlan: ActivationAndFlightPlan } }
  | { type: 'DELETE'; payload: number }
  | { type: 'SET_ALL'; payload: ActivationAndFlightPlan[] };

function reducer(state: typeof initialState, action: ActivationAndFlightPlansStateAction) {
  switch (action.type) {
    case 'ADD':
      return activationAndFlightPlansAdapter.addOne(state, {
        activation: action.payload.activation,
        flightPlan: action.payload.flightPlan,
      });
    case 'UPDATE': {
      const { activationId, activationAndFlightPlan } = action.payload;
      return activationAndFlightPlansAdapter.updateOne(state, {
        id: activationId,
        changes: {
          flightPlan: activationAndFlightPlan.flightPlan,
          activation: activationAndFlightPlan.activation,
        },
      });
    }
    case 'DELETE':
      return activationAndFlightPlansAdapter.removeOne(state, action.payload);
    case 'SET_ALL':
      return activationAndFlightPlansAdapter.setAll(state, action.payload);
    default:
      return state;
  }
}

export const useActivationAndFlightPlansState = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return { state, dispatch };
};
